/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Rest_Api_S3_Li1Inputs */

const en_guide_json_rest_api_s3_li1 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Single resource</strong>: <code>&#123;"data": &#123;...&#125;&#125;</code> wraps the object`)
};

const ko_guide_json_rest_api_s3_li1 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>단일 리소스</strong>: <code>&#123;"data": &#123;...&#125;&#125;</code>로 객체를 감쌈`)
};

const ja_guide_json_rest_api_s3_li1 = /** @type {(inputs: Guide_Json_Rest_Api_S3_Li1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>単一リソース</strong>: <code>&#123;"data": &#123;...&#125;&#125;</code>でオブジェクトをラップ`)
};

/**
* | output |
* | --- |
* | "<strong>Single resource</strong>: <code>&#123;\"data\": &#123;...&#125;&#125;</code> wraps the object" |
*
* @param {Guide_Json_Rest_Api_S3_Li1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_rest_api_s3_li1 = /** @type {((inputs?: Guide_Json_Rest_Api_S3_Li1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Rest_Api_S3_Li1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_rest_api_s3_li1(inputs)
	if (locale === "ko") return ko_guide_json_rest_api_s3_li1(inputs)
	return ja_guide_json_rest_api_s3_li1(inputs)
});